// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"ON-z","carouselContainer":"PN-z"};